/**
 * api接口的统一出口
*/
import Login from '@/api/Login';
import setup from '@/api/setup';
import goods from '@/api/goods';
import order from '@/api/order';
import info  from '@/api/info';
import home from  '@/api/home';
import cabinet from  '@/api/cabinet';


export default {
    Login,
    setup,
    order,
    info,
    home,
    goods,
    cabinet
}



// WEBPACK FOOTER //
// ./src/api/index.js